import type {
  ICreditReport,
  ICreditReportCredit
} from '@/shared/types/scoring-info.types';

/** Действующие кредиты отчёта: строки без номера договора (заявки) не показываются. */
export const getActiveCredits = (
  report: ICreditReport
): ICreditReportCredit[] =>
  report.credits.active.filter((credit) => Boolean(credit.contractCode));

/** Есть ли просрочка в сумме из отчёта: `186 400,00 ₸` — да, `0,00 ₸` — нет. */
export const isOverdueAmount = (overdue: string): boolean =>
  Number(overdue.replace(/[^\d,]/g, '').replace(',', '.')) > 0;
